<template>
  <slot>
    <template v-if="isWizardStep">
      <div class="govuk-wizard-step" :data-step-id="index" v-show="!state.hidden">
        <fieldset :id="identifier" class="govuk-fieldset govuk-slide-box">
          <legend>
            <label class="govuk-label govuk-label--l" v-show="!state.titleHidden">
              <slot name="title">
                <h2 class="heading-medium" v-html="displayTitle"></h2>
              </slot>
            </label>
            <div class="govuk-hint" v-show="!state.descriptionHidden">
              <slot name="description">
                <span v-html="displayDescription"></span>
              </slot>
            </div>
          </legend>
          <slot name="content">No content was inserted.</slot>
        </fieldset>
      </div>
    </template>
    <template v-else>
      <fieldset :id="identifier" class="govuk-fieldset" v-show="!state.hidden">
        <legend>
          <label class="govuk-label govuk-label--l" v-show="!state.titleHidden">
            <slot name="title">
              <h3 class="heading-medium" v-html="displayTitle"></h3>
            </slot>
          </label>
          <div class="govuk-hint" v-show="!state.descriptionHidden">
            <slot name="description">
              <span v-html="displayDescription"></span>
            </slot>
          </div>
        </legend>
        <slot name="content">No content was inserted.</slot>
      </fieldset>
    </template>
  </slot>
</template>
<script lang="ts" src="@/library/templates/default/controls/AccordionSection.ts"></script>
